import { RemoteAdminData } from 'app/infrastructure/remote-data';
import { ApiResponse, Value } from 'app/types-shared';
import { endpoints } from './endpoints';
import { DashboardItemWire, RootCode } from './types';

export const api = {

  loadLanguageOptions: async (): Promise<Value[]> => {
    const response = await new RemoteAdminData(endpoints.languageOptions)
      .resource<ApiResponse<Value[]>>()
      .all();

    return response.data;
  },

  loadRootUserGroups: async (): Promise<RootCode> => {
    const response = await new RemoteAdminData(endpoints.userGroupOptions)
      .resource<ApiResponse<RootCode>>()
      .filter({ levels: 1 })
      .all();

    return response.data;
  },

  loadRootCaseTypes: async (): Promise<RootCode> => {
    const response = await new RemoteAdminData(endpoints.caseTypeOptions)
      .resource<ApiResponse<RootCode>>()
      .filter({ levels: 1 })
      .all();

    return response.data;
  },

  loadAccessTypes: async (): Promise<Value[]> => {
    const response = await new RemoteAdminData(endpoints.accessTypeOptions)
      .resource<ApiResponse<Value[]>>()
      .all();

    return response.data;
  },

  loadDashboard: async (id: number): Promise<DashboardItemWire> => {
    const response = await new RemoteAdminData(endpoints.dashboardItem)
      .resource<ApiResponse<DashboardItemWire>>()
      .withId(id)
      .single();

    return response.data;
  },

  deleteDashboard: (id: number): Promise<void> => {
    return new RemoteAdminData(endpoints.dashboardItem)
      .resource<void>()
      .withId(id)
      .httpDelete({});
  },

  createDashboard: async (dashboard: DashboardItemWire): Promise<number> => {

    const response: any = await new RemoteAdminData(endpoints.dashboardItem)
      .resource<ApiResponse<number>>()
      .create(dashboard, false);

    const json: ApiResponse<number> = await response.json();

    return json.data;
  },

  saveDashboard: async (id: number, dashboard: DashboardItemWire): Promise<number> => {

    await new RemoteAdminData(endpoints.dashboardItem)
      .resource<void>()
      .withId(id)
      .save(dashboard);

    return id;
  }
};
